/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** ConversationReportItemType */
export enum ConversationReportItemType {
  Summary = "summary",
  ActionItem = "action_item",
  Decision = "decision",
  Question = "question",
  AgendaItem = "agenda_item",
  Text = "text",
}

/** ActiveMeetRoomItem */
export interface ActiveMeetRoomItem {
  /** Workspace Id */
  workspace_id: string;
  /** Meeting Group Id */
  meeting_group_id?: string | null;
  /** Workspace Name */
  workspace_name?: string | null;
  /** Room Id */
  room_id: string;
  /** Room Url */
  room_url?: string | null;
  /**
   * Participants Count
   * @default 0
   */
  participants_count?: number;
  /** Participant Display Names */
  participant_display_names?: string[];
}

/** ActiveMeetRoomListResponse */
export interface ActiveMeetRoomListResponse {
  /** Items */
  items: ActiveMeetRoomItem[];
}

/**
 * ActiveParticipantResponse
 * Response model for active participant.
 */
export interface ActiveParticipantResponse {
  /** Livekit Identity */
  livekit_identity: string;
  /** Livekit Sid */
  livekit_sid: string;
  /** Display Name */
  display_name: string;
  /** Protocolist User Id */
  protocolist_user_id?: string | null;
  /**
   * Is Protocolist User
   * @default false
   */
  is_protocolist_user?: boolean;
  /** Joined At */
  joined_at?: number | null;
  /**
   * Is Admin
   * @default false
   */
  is_admin?: boolean;
}

/** BasicInformation */
export interface BasicInformation {
  /**
   * Title
   * @default "Основная информация"
   */
  title?: string;
  /** Participants */
  participants?: string[];
  /** Started At */
  started_at?: string | null;
  /** Ended At */
  ended_at?: string | null;
  /** Meeting Title */
  meeting_title?: string | null;
  /** Provider Id */
  provider_id?: string | null;
}

/** Body_finalize_call_with_file_internal_conversation_finalize_call_with_file_post */
export interface BodyFinalizeCallWithFileInternalConversationFinalizeCallWithFilePost {
  /** Payload */
  payload: string;
  /** File */
  file?: string | null;
}

/** Body_upload_meeting_group_audio_meeting_groups__meeting_group_id__uploads_audio_post */
export interface BodyUploadMeetingGroupAudioMeetingGroupsMeetingGroupIdUploadsAudioPost {
  /** File */
  file?: string | null;
  /** Audio File */
  audio_file?: string | null;
}

/** Body_upload_meeting_group_audio_meeting_groups__meeting_group_id__uploads_post */
export interface BodyUploadMeetingGroupAudioMeetingGroupsMeetingGroupIdUploadsPost {
  /** File */
  file?: string | null;
  /** Audio File */
  audio_file?: string | null;
}

/** BroadcastRequest */
export interface BroadcastRequest {
  /** User Ids */
  user_ids: string[];
  /** Title */
  title: string;
  /** Body */
  body: string;
  /** Data */
  data?: Record<string, any> | null;
}

/** ChunkEnqueueResponse */
export interface ChunkEnqueueResponse {
  /** Conversation Id */
  conversation_id: string;
  /** Chunk Id */
  chunk_id: number;
  /** Created New Conversation */
  created_new_conversation: boolean;
}

/** ChunkPayload */
export interface ChunkPayload {
  /** Conversation Id */
  conversation_id: string;
  /** Workspace Id */
  workspace_id?: string | null;
  /** Provider Id */
  provider_id?: string | null;
  /** Provider External Id */
  provider_external_id?: string | null;
  /** Participant Id */
  participant_id?: string | null;
  /** Provider User Id */
  provider_user_id?: string | null;
  /** Provider User Name */
  provider_user_name?: string | null;
  /** Provider User Display Name */
  provider_user_display_name?: string | null;
  /** Payload Type */
  payload_type?: string | null;
  /** Metadata */
  metadata?: Record<string, any>;
  /**
   * Text
   * @default ""
   */
  text?: string;
  /** Begin Ts */
  begin_ts?: string | null;
  /** End Ts */
  end_ts?: string | null;
}

/** CompanyListResponse */
export interface CompanyListResponse {
  /** Items */
  items: CompanyResponse[];
}

/** CompanyResponse */
export interface CompanyResponse {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
  /** Role */
  role?: string | null;
}

/**
 * CompanyUserItemResponse
 * One company member for list endpoint.
 */
export interface CompanyUserItemResponse {
  /** User Id */
  user_id: string;
  /** Display Name */
  display_name?: string | null;
  /** External User Id */
  external_user_id?: string | null;
  /** Role */
  role: string;
}

/** CompanyUserListResponse */
export interface CompanyUserListResponse {
  /** Items */
  items: CompanyUserItemResponse[];
}

/**
 * CompanyUserRoleUpdateRequest
 * role: owner | admin | member. Only owner can change owner role.
 */
export interface CompanyUserRoleUpdateRequest {
  /**
   * Role
   * @minLength 1
   * @maxLength 32
   */
  role: string;
}

/** ConversationChunkItem */
export interface ConversationChunkItem {
  /** Id */
  id: number;
  /** Begin Ts */
  begin_ts?: string | null;
  /** End Ts */
  end_ts?: string | null;
  /** Display Name */
  display_name?: string | null;
  /** Text */
  text: string;
  /** Participant Id */
  participant_id?: string | null;
  /** Provider User Id */
  provider_user_id?: string | null;
  /** Payload Type */
  payload_type?: string | null;
  /** User Id */
  user_id?: string | null;
}

/** ConversationChunksResponse */
export interface ConversationChunksResponse {
  /** Items */
  items: ConversationChunkItem[];
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
}

/** ConversationCompletePayload */
export interface ConversationCompletePayload {
  /** Ended At */
  ended_at?: string | null;
  /** Reason */
  reason?: string | null;
  /** Metadata */
  metadata?: Record<string, any>;
}

/** ConversationCreatePayload */
export interface ConversationCreatePayload {
  /** Provider Id */
  provider_id: string;
  /** Workspace Id */
  workspace_id: string;
  /** Title */
  title?: string | null;
  /** External Id */
  external_id?: string | null;
  /** Scheduled At */
  scheduled_at?: string | null;
  /** Metadata */
  metadata?: Record<string, any>;
  /** Participants */
  participants?: ParticipantPayload[];
}

/** ConversationFinalizePayload */
export interface ConversationFinalizePayload {
  /** Finalized By */
  finalized_by?: string | null;
  /** Ended At */
  ended_at?: string | null;
  /** Metadata */
  metadata?: Record<string, any>;
  /** Result */
  result?: string | null;
  /**
   * Wait Last Chunk
   * @default true
   */
  wait_last_chunk?: boolean;
}

/** ConversationInviteRequest */
export interface ConversationInviteRequest {
  /** User Ids */
  user_ids: string[];
}

/** ConversationInviteResponse */
export interface ConversationInviteResponse {
  /** Conversation Id */
  conversation_id: string;
  /** Invited Count */
  invited_count: number;
  /** Skipped Count */
  skipped_count: number;
  /** Results */
  results: ConversationInviteResult[];
}

/** ConversationInviteResult */
export interface ConversationInviteResult {
  /** User Id */
  user_id: string;
  /** Display Name */
  display_name?: string | null;
  /** Status */
  status: string;
  /**
   * Sent Tokens
   * @default 0
   */
  sent_tokens?: number;
  /**
   * Total Tokens
   * @default 0
   */
  total_tokens?: number;
  /** Error */
  error?: string | null;
}

/** ConversationListItem */
export interface ConversationListItem {
  /** Conversation Id */
  conversation_id: string;
  /** Status */
  status: string;
  /** Provider Id */
  provider_id: string;
  /** Workspace Id */
  workspace_id: string;
  /** Meeting Group Id */
  meeting_group_id?: string | null;
  /** Started At */
  started_at?: string | null;
  /** Ended At */
  ended_at?: string | null;
}

/** ConversationListResponse */
export interface ConversationListResponse {
  /** Items */
  items: ConversationListItem[];
}

/** ConversationMergeRequest */
export interface ConversationMergeRequest {
  /**
   * Conversation Ids
   * IDs of conversations to merge
   * @minItems 2
   */
  conversation_ids: string[];
}

/** ConversationMergeResponse */
export interface ConversationMergeResponse {
  conversation: ConversationStatusResponse;
  /** Chunks */
  chunks: ConversationChunkItem[];
}

/** ConversationReportCreate */
export interface ConversationReportCreate {
  /** Title */
  title: string;
}

/** ConversationReportDTO */
export interface ConversationReportDTO {
  /** Id */
  id: string;
  /** Conversation Id */
  conversation_id: string;
  /** Title */
  title: string;
  /**
   * Created At
   * @format date-time
   */
  created_at: string;
  /** Updated At */
  updated_at?: string | null;
}

/** ConversationReportItemCreate */
export interface ConversationReportItemCreate {
  /** Title */
  title: string;
  type: ConversationReportItemType;
  /** Data */
  data?: Record<string, any> | null;
}

/** ConversationReportItemDTO */
export interface ConversationReportItemDTO {
  /** Id */
  id: string;
  /** Report Id */
  report_id: string;
  /** Title */
  title: string;
  type: ConversationReportItemType;
  /** Data */
  data?: Record<string, any>;
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
}

/** ConversationReportItemUpdate */
export interface ConversationReportItemUpdate {
  /** Title */
  title: string;
  /** Data */
  data?: Record<string, any> | null;
}

/** ConversationReportWithItemsCreate */
export interface ConversationReportWithItemsCreate {
  /** Title */
  title: string;
  /** Items */
  items?: ConversationReportItemCreate[];
}

/** ConversationReportWithItemsDTO */
export interface ConversationReportWithItemsDTO {
  /** Id */
  id: string;
  /** Conversation Id */
  conversation_id: string;
  /** Title */
  title: string;
  /** Items */
  items?: ConversationReportItemDTO[];
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
}

/** ConversationReportsBatchCreate */
export interface ConversationReportsBatchCreate {
  /** Conversation Id */
  conversation_id?: string | null;
  /** Items */
  items: ConversationReportWithItemsCreate[];
}

/** ConversationStartPayload */
export interface ConversationStartPayload {
  /** Started By */
  started_by?: string | null;
  /** Started At */
  started_at?: string | null;
  /** Metadata */
  metadata?: Record<string, any>;
}

/** ConversationStatusResponse */
export interface ConversationStatusResponse {
  /** Conversation Id */
  conversation_id: string;
  /** Status */
  status: string;
  /** Substatus */
  substatus?: string | null;
  /** Started At */
  started_at: string | null;
  /** Ended At */
  ended_at: string | null;
  /** Workspace Id */
  workspace_id: string;
  /** Provider Id */
  provider_id: string;
  /** Metadata */
  metadata: Record<string, any>;
  /** Workspace */
  workspace?: WorkspaceResponse | MeetWorkspaceDetailResponse | null;
}

/** ConversationStatusUpdateRequest */
export interface ConversationStatusUpdateRequest {
  /** Status */
  status?: string | null;
  /** Substatus */
  substatus?: string | null;
}

/** CreateCompanyRequest */
export interface CreateCompanyRequest {
  /**
   * Name
   * @minLength 1
   * @maxLength 256
   */
  name: string;
}

/**
 * CreateInvitationRequest
 * invitee_id_or_external: app_user.id or external_user_id.
 */
export interface CreateInvitationRequest {
  /**
   * Invitee Id Or External
   * @minLength 1
   * @maxLength 128
   */
  invitee_id_or_external: string;
}

/** EventPayload */
export interface EventPayload {
  /** Provider Id */
  provider_id: string;
  /** Workspace Id */
  workspace_id: string;
  /** Conversation Id */
  conversation_id: string;
  /** Event Type */
  event_type: string;
  /** Payload */
  payload?: Record<string, any>;
}

/** FeedbackRequest */
export interface FeedbackRequest {
  /** Message Id */
  message_id: string;
  /**
   * Rating
   * Оценка от 1 до 5 звезд
   * @min 1
   * @max 5
   */
  rating: number;
  /**
   * Comment
   * Комментарий пользователя
   * @default ""
   */
  comment?: string;
}

/** FinalizeCallResponse */
export interface FinalizeCallResponse {
  /** Accepted */
  accepted: boolean;
  /** Conversation Id */
  conversation_id: string;
}

/**
 * FlowAIWebhookUrlResponse
 * Response with suggested webhook URL for FlowAI provider.
 */
export interface FlowAIWebhookUrlResponse {
  /**
   * Suggested Webhook Url
   * Suggested webhook URL: {FLOWAI_WEBHOOK_DOMAIN}/webhook/flowai
   */
  suggested_webhook_url: string;
}

/** GoogleCalendarCreateRequest */
export interface GoogleCalendarCreateRequest {
  /** Client Id */
  client_id: string;
  /** Client Secret */
  client_secret: string;
  /** Redirect Uri */
  redirect_uri: string;
  /**
   * Timezone
   * @default "Europe/Moscow"
   */
  timezone?: string;
}

/** GoogleCalendarUpdateRequest */
export interface GoogleCalendarUpdateRequest {
  /** Client Id */
  client_id?: string | null;
  /** Client Secret */
  client_secret?: string | null;
  /** Redirect Uri */
  redirect_uri?: string | null;
}

/** GuildSummary */
export interface GuildSummary {
  /** Discord Guild Id */
  discord_guild_id: string;
  /** Label */
  label: string;
  /** Status */
  status: string;
  /**
   * Transcription
   * @default false
   */
  transcription?: boolean;
  /** Created At */
  created_at?: string | null;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** IngestChunkRequest */
export interface IngestChunkRequest {
  /** Guild Id */
  guild_id: string;
  /** Session Hint */
  session_hint?: Record<string, any> | null;
  chunk: InternalChunk;
  /** Provider Id */
  provider_id?: string | null;
  /** Workspace Id */
  workspace_id?: string | null;
  /** Conversation Id */
  conversation_id?: string | null;
  /** Participant Id */
  participant_id?: string | null;
  /** Provider User Id */
  provider_user_id?: string | null;
  /** Source */
  source?: Record<string, any> | null;
  /** Sequence */
  sequence?: number | null;
}

/** IngestChunkResponse */
export interface IngestChunkResponse {
  /** Accepted */
  accepted: boolean;
  /** Conversation Id */
  conversation_id: string;
  /** Chunk Id */
  chunk_id: number;
}

/** InternalChunk */
export interface InternalChunk {
  /** Begin Ts */
  begin_ts?: string | null;
  /** End Ts */
  end_ts?: string | null;
  /** Provider User Id */
  provider_user_id?: string | null;
  /** Provider User Name */
  provider_user_name?: string | null;
  /** Provider User Display Name */
  provider_user_display_name?: string | null;
  /** Text */
  text: string;
  /** Raw */
  raw?: Record<string, any> | null;
  /** Participant Id */
  participant_id?: string | null;
  /** Payload Type */
  payload_type?: string | null;
  /** Metadata */
  metadata?: Record<string, any> | null;
}

/** InvitationListResponse */
export interface InvitationListResponse {
  /** Items */
  items: InvitationResponse[];
}

/** InvitationResponse */
export interface InvitationResponse {
  /** Id */
  id: string;
  /** Company Id */
  company_id: string;
  /** Inviter Id */
  inviter_id: string;
  /** Invitee Id */
  invitee_id: string;
  /** Invitee Display Name */
  invitee_display_name?: string | null;
  /** Status */
  status: string;
  /** Created At */
  created_at?: string | null;
}

/** InviteCandidateItemResponse */
export interface InviteCandidateItemResponse {
  /** User Id */
  user_id: string;
  /** Display Name */
  display_name: string;
  /** External User Id */
  external_user_id?: string | null;
}

/** InviteCandidateListResponse */
export interface InviteCandidateListResponse {
  /** Items */
  items: InviteCandidateItemResponse[];
}

/** InviteResponse */
export interface InviteResponse {
  /** Invite Url */
  invite_url: string;
}

/** JiraApprovalRequest */
export interface JiraApprovalRequest {
  /** Payload */
  payload: Record<string, any>;
}

/** JiraApprovalResponse */
export interface JiraApprovalResponse {
  /** Success */
  success: boolean;
  /** Data */
  data?: Record<string, any> | null;
  /** Message */
  message: string;
}

/** JiraCreateRequest */
export interface JiraCreateRequest {
  /** Username */
  username: string;
  /** Password */
  password: string;
  /** Url */
  url: string;
  /** Is Cloud */
  is_cloud: boolean;
}

/** JiraUpdateRequest */
export interface JiraUpdateRequest {
  /** Username */
  username?: string | null;
  /** Password */
  password?: string | null;
  /** Url */
  url?: string | null;
  /** Is Cloud */
  is_cloud?: boolean | null;
}

/** LinkGuildRequest */
export interface LinkGuildRequest {
  /**
   * Guild Id
   * Discord Guild ID (must be a numeric string)
   */
  guild_id: string;
}

/** LinkGuildResponse */
export interface LinkGuildResponse {
  /** Guild Id */
  guild_id: string;
  /** Linked */
  linked: boolean;
}

/** LinkedGuildResponse */
export interface LinkedGuildResponse {
  /** Linked */
  linked: boolean;
}

/** MeetChunkRequest */
export interface MeetChunkRequest {
  /** Text */
  text: string;
  /** Start Time */
  start_time: number;
  /** End Time */
  end_time: number;
  /** Confidence */
  confidence: number;
  /** Timestamp */
  timestamp: string;
  /** Participant Name */
  participant_name?: string | null;
  /** Metadata */
  metadata?: Record<string, any> | null;
}

/** MeetChunkResponse */
export interface MeetChunkResponse {
  /** Accepted */
  accepted: boolean;
  /** Conversation Id */
  conversation_id?: string | null;
  /** Chunk Id */
  chunk_id?: number | null;
}

/** MeetEndConversationRequest */
export interface MeetEndConversationRequest {
  /** Conversation Id */
  conversation_id: string;
  /** Message Payload */
  message_payload: Record<string, any>;
}

/** MeetEndConversationResponse */
export interface MeetEndConversationResponse {
  /** Conversation Id */
  conversation_id: string;
  /** Status */
  status: string;
  /** All Chunks Received */
  all_chunks_received: boolean;
}

/** MeetStartConversationRequest */
export interface MeetStartConversationRequest {
  /** External Id */
  external_id: string;
}

/** MeetStartConversationResponse */
export interface MeetStartConversationResponse {
  /** Conversation Id */
  conversation_id: string;
}

/** MeetWorkspaceCreateRequest */
export interface MeetWorkspaceCreateRequest {
  /** Name */
  name: string;
  /** Company Id */
  company_id?: string | null;
  /** Meeting Group Id */
  meeting_group_id?: string | null;
  /** Default Meeting Group Id */
  default_meeting_group_id?: string | null;
  /**
   * Is Protected
   * @default false
   */
  is_protected?: boolean;
}

/** MeetWorkspaceCreateResponse */
export interface MeetWorkspaceCreateResponse {
  /** Workspace Id */
  workspace_id: string;
  /** Room Id */
  room_id: string;
  /** Meet Room Id */
  meet_room_id: string;
  /** Slug */
  slug: string;
  /** Webhook Url */
  webhook_url: string;
  /** Room Url */
  room_url: string;
  /** Pin Code */
  pin_code?: string | null;
  /**
   * Is Protected
   * @default false
   */
  is_protected?: boolean;
  /** Access Code */
  access_code?: string | null;
  /** Admin Code */
  admin_code?: string | null;
  /** Admin Url */
  admin_url?: string | null;
}

/** MeetWorkspaceDetailResponse */
export interface MeetWorkspaceDetailResponse {
  /** Workspace Id */
  workspace_id: string;
  /** Room Id */
  room_id: string;
  /** Meet Room Id */
  meet_room_id: string;
  /** Slug */
  slug: string;
  /** Room Url */
  room_url: string;
  /** Pin Code */
  pin_code?: string | null;
  /** Display Name */
  display_name?: string | null;
  /**
   * Is Protected
   * @default false
   */
  is_protected?: boolean;
  /** Access Code */
  access_code?: string | null;
  /** Admin Code */
  admin_code?: string | null;
  /** Admin Url */
  admin_url?: string | null;
}

/**
 * MeetWorkspaceLinksResponse
 * Response DTO для получения ссылок на комнату.
 */
export interface MeetWorkspaceLinksResponse {
  /** Room Url */
  room_url: string;
  /** Admin Url */
  admin_url: string;
  /** Pin Code */
  pin_code?: string | null;
  /**
   * Is Protected
   * @default false
   */
  is_protected?: boolean;
  /** Access Code */
  access_code?: string | null;
}

/** MeetingGroupAudioUploadResponse */
export interface MeetingGroupAudioUploadResponse {
  /** Upload Job Id */
  upload_job_id: string;
  /** Meeting Group Id */
  meeting_group_id: string;
  /** Conversation Id */
  conversation_id: string;
  /** Workspace Id */
  workspace_id: string;
  /** Provider Id */
  provider_id: string;
  /** Status */
  status: string;
  /** File Name */
  file_name: string;
  /** File Size */
  file_size: number;
  /** Content Type */
  content_type?: string | null;
  /** Created At */
  created_at?: string | null;
}

/** MeetingGroupAudioUploadStatusResponse */
export interface MeetingGroupAudioUploadStatusResponse {
  /** Upload Job Id */
  upload_job_id: string;
  /** Meeting Group Id */
  meeting_group_id: string;
  /** Conversation Id */
  conversation_id: string;
  /** Status */
  status: string;
  /** Error Message */
  error_message?: string | null;
  /** File Name */
  file_name: string;
  /** File Size */
  file_size: number;
  /** Content Type */
  content_type?: string | null;
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
}

/** MeetingGroupCreateRequest */
export interface MeetingGroupCreateRequest {
  /** Company Id */
  company_id?: string | null;
  /**
   * Name
   * @minLength 1
   * @maxLength 128
   */
  name: string;
  /** Description */
  description?: string | null;
}

/** MeetingGroupListResponse */
export interface MeetingGroupListResponse {
  /** Items */
  items: MeetingGroupResponse[];
}

/** MeetingGroupMember */
export interface MeetingGroupMember {
  /** User Id */
  user_id: string;
  /** External User Id */
  external_user_id?: string | null;
  /** Display Name */
  display_name?: string | null;
  /** Role */
  role: string;
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
}

/** MeetingGroupMemberAddRequest */
export interface MeetingGroupMemberAddRequest {
  /**
   * User Id
   * @minLength 1
   * @maxLength 128
   */
  user_id: string;
  /**
   * Role
   * @minLength 1
   * @maxLength 32
   * @default "member"
   */
  role?: string;
}

/** MeetingGroupMemberRoleUpdateRequest */
export interface MeetingGroupMemberRoleUpdateRequest {
  /**
   * Role
   * @minLength 1
   * @maxLength 32
   */
  role: string;
}

/** MeetingGroupResponse */
export interface MeetingGroupResponse {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Company Id */
  company_id?: string | null;
  /** Created At */
  created_at?: string | null;
  /** Updated At */
  updated_at?: string | null;
  /** Members */
  members?: MeetingGroupMember[];
  /** Role */
  role?: string | null;
}

/** MeetingGroupUpdateRequest */
export interface MeetingGroupUpdateRequest {
  /** Name */
  name?: string | null;
  /** Description */
  description?: string | null;
}

/** NotifyConversationUpdatedBody */
export interface NotifyConversationUpdatedBody {
  /** Conversation Id */
  conversation_id: string;
  /** Payload */
  payload?: Record<string, any> | null;
}

/** NotifyProtocolCreatedBody */
export interface NotifyProtocolCreatedBody {
  /** Conversation Id */
  conversation_id: string;
  /** Payload */
  payload?: Record<string, any> | null;
}

/** PaginatedResponse[GuildSummary] */
export interface PaginatedResponseGuildSummary {
  /** Items */
  items: GuildSummary[];
  /** Total */
  total: number;
  /** Page */
  page: number;
  /** Page Size */
  page_size: number;
  /** Total Pages */
  total_pages: number;
}

/** ParticipantPayload */
export interface ParticipantPayload {
  /** External Id */
  external_id?: string | null;
  /** Display Name */
  display_name?: string | null;
  /** Role */
  role?: string | null;
  /** Metadata */
  metadata?: Record<string, any>;
  /** Participant Id */
  participant_id?: string | null;
  /**
   * Is Active
   * @default true
   */
  is_active?: boolean;
}

/** ParticipantsChangedBody */
export interface ParticipantsChangedBody {
  /** Conversation Id */
  conversation_id: string;
  /** Action */
  action: string;
  /** Participant Identity */
  participant_identity?: string | null;
  /** Participant Name */
  participant_name?: string | null;
  /** Total Count */
  total_count: number;
}

/** ProtocolAnswer */
export interface ProtocolAnswer {
  /** Answer */
  answer: string;
}

/**
 * ProtocolGraphResponse
 * Полный протокол встречи из Neo4j
 */
export interface ProtocolGraphResponse {
  /** Основная информация о протоколе встречи */
  protocol: ProtocolMetadataDTO;
  basic_info: BasicInformation;
  /** Agenda */
  agenda?: string[];
  /** Topics */
  topics?: TopicItemDTO[];
  /** Meeting Results */
  meeting_results?: ProtocolItemDTO[];
  /** Additional Notes */
  additional_notes?: ProtocolItemDTO[];
}

/** ProtocolImportRequest */
export interface ProtocolImportRequest {
  /** Text */
  text: string;
  /** Group Id */
  group_id?: string | null;
  /** Workspace Id */
  workspace_id?: string | null;
  /** Conversation Id */
  conversation_id?: string | null;
}

/** ProtocolImportResponse */
export interface ProtocolImportResponse {
  /** Status */
  status: string;
  /** Task Id */
  task_id: string;
  /** Conversation Id */
  conversation_id: string;
}

/**
 * ProtocolItemDTO
 * Элемент протокола (Итоги встречи, Дополнительные заметки)
 */
export interface ProtocolItemDTO {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /** Content */
  content: string;
  /** Type */
  type: string;
}

/**
 * ProtocolMetadataDTO
 * Основная информация о протоколе встречи
 */
export interface ProtocolMetadataDTO {
  /** Conversation Id */
  conversation_id: string;
  /** Meeting Title */
  meeting_title?: string | null;
  /** Started At */
  started_at?: string | null;
  /** Ended At */
  ended_at?: string | null;
  /** Participants */
  participants?: string[];
  /** Provider Id */
  provider_id?: string | null;
  /** Workspace Id */
  workspace_id: string;
}

/** ProviderItem */
export interface ProviderItem {
  /** Id */
  id: string;
  /** Provider Type */
  provider_type: string;
  /** Name */
  name: string;
  /** Capabilities */
  capabilities?: Record<string, any>;
  /** Is Active */
  is_active: boolean;
}

/** ProviderListResponse */
export interface ProviderListResponse {
  /** Items */
  items: ProviderItem[];
}

/**
 * RegenerateAccessCodeResponse
 * Response DTO после регенерации кода.
 */
export interface RegenerateAccessCodeResponse {
  /** Workspace Id */
  workspace_id: string;
  /** Access Code */
  access_code: string;
}

/** RegisterTokenRequest */
export interface RegisterTokenRequest {
  /** Token */
  token: string;
  /** Platform */
  platform: string;
  /** App Version */
  app_version?: string | null;
  /** Device Model */
  device_model?: string | null;
}

/** ReportItemInfo */
export interface ReportItemInfo {
  /** Id */
  id: string;
  /** Title */
  title: string;
}

/** ReportTreeResponse */
export interface ReportTreeResponse {
  /** Reports */
  reports: ReportWithItemsInfo[];
}

/** ReportWithItemsInfo */
export interface ReportWithItemsInfo {
  /** Id */
  id: string;
  /** Title */
  title: string;
  /** Items */
  items: ReportItemInfo[];
}

/**
 * ResponsiblePersonDTO
 * Структурированный ответственный с привязкой к пользователю
 */
export interface ResponsiblePersonDTO {
  /** Display Name */
  display_name: string;
  /** User Id */
  user_id?: string | null;
  /** External User Id */
  external_user_id?: string | null;
}

/** StatusMappingsResponse */
export interface StatusMappingsResponse {
  /** Status */
  status: Record<string, string>;
  /** Substatus */
  substatus: Record<string, string>;
}

/** TestNotificationRequest */
export interface TestNotificationRequest {
  /**
   * Title
   * @default "Test Notification"
   */
  title?: string;
  /**
   * Body
   * @default "This is a test push notification"
   */
  body?: string;
  /** Data */
  data?: Record<string, any> | null;
}

/** TokenListResponse */
export interface TokenListResponse {
  /** Items */
  items: TokenResponse[];
}

/** TokenResponse */
export interface TokenResponse {
  /** Id */
  id: string;
  /** Token */
  token: string;
  /** Platform */
  platform: string;
  /** App Version */
  app_version: string | null;
  /** Device Model */
  device_model: string | null;
  /** Is Active */
  is_active: boolean;
  /** Created At */
  created_at: string;
  /** Last Used At */
  last_used_at?: string | null;
}

/**
 * TopicItemDTO
 * Тема встречи
 */
export interface TopicItemDTO {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Description */
  description?: string | null;
  /** Decisions */
  decisions?: string[];
  /** Deadlines */
  deadlines?: any[];
  /** Responsible */
  responsible?: ResponsiblePersonDTO[];
}

/**
 * UpdateAdminCodeRequest
 * Request DTO для обновления кода администратора.
 */
export interface UpdateAdminCodeRequest {
  /**
   * Regenerate
   * @default true
   */
  regenerate?: boolean;
}

/**
 * UpdateAdminCodeResponse
 * Response DTO после обновления кода администратора.
 */
export interface UpdateAdminCodeResponse {
  /** Workspace Id */
  workspace_id: string;
  /** Admin Code */
  admin_code: string;
  /** Admin Url */
  admin_url: string;
}

/**
 * UpdateCompanyRequest
 * Request DTO for updating company name.
 */
export interface UpdateCompanyRequest {
  /**
   * Name
   * @minLength 1
   * @maxLength 256
   */
  name: string;
}

/** UpdateDisplayNameRequest */
export interface UpdateDisplayNameRequest {
  /**
   * Display Name
   * @minLength 1
   * @maxLength 128
   */
  display_name: string;
}

/**
 * UpdateMeetWorkspacePrivacyRequest
 * Request DTO для обновления настроек приватности.
 */
export interface UpdateMeetWorkspacePrivacyRequest {
  /** Is Protected */
  is_protected: boolean;
}

/**
 * UpdateMeetWorkspacePrivacyResponse
 * Response DTO после обновления настроек приватности.
 */
export interface UpdateMeetWorkspacePrivacyResponse {
  /** Workspace Id */
  workspace_id: string;
  /** Is Protected */
  is_protected: boolean;
  /** Access Code */
  access_code?: string | null;
}

/** UpdateNodeRequest */
export interface UpdateNodeRequest {
  /** Fields */
  fields: Record<string, any>;
}

/** UpdateNodeResponse */
export interface UpdateNodeResponse {
  /** Node */
  node: Record<string, any>;
  /** Node Type */
  node_type: string | null;
  /** Ignored Fields */
  ignored_fields: string[];
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
  /** Input */
  input?: any;
  /** Context */
  ctx?: object;
}

/** VoiceChannelSummary */
export interface VoiceChannelSummary {
  /** Id */
  id: string;
  /** Name */
  name: string;
  /** Bitrate */
  bitrate: number;
  /** User Limit */
  user_limit?: number | null;
  /** Is Connected */
  is_connected: boolean;
  /** Provider Id */
  provider_id?: string | null;
}

/** VoiceChannelsResponse */
export interface VoiceChannelsResponse {
  /** Channels */
  channels: VoiceChannelSummary[];
}

/** VoiceConnectRequest */
export interface VoiceConnectRequest {
  /** Guild Id */
  guild_id: string;
  /** Channel Id */
  channel_id: string;
  /** Meeting Group Id */
  meeting_group_id?: string | null;
}

/** VoiceDisconnectRequest */
export interface VoiceDisconnectRequest {
  /** Guild Id */
  guild_id: string;
}

/** VoiceOperationResponse */
export interface VoiceOperationResponse {
  /** Ok */
  ok: boolean;
  /** Conversation Id */
  conversation_id?: string | null;
}

/** WebhookProtocolRequest */
export interface WebhookProtocolRequest {
  /** Conversation Id */
  conversation_id: string;
  /** Responses */
  responses: WebhookResponseItem[] | Record<string, ProtocolAnswer>;
  general?: ProtocolAnswer | null;
}

/** WebhookResponseItem */
export interface WebhookResponseItem {
  /** User Id */
  user_id: string;
  /** Answer */
  answer: string;
}

/** WorkspaceCreatePayload */
export interface WorkspaceCreatePayload {
  /** External Id */
  external_id: string;
  /** Display Name */
  display_name?: string | null;
  /** Settings */
  settings?: Record<string, any>;
  /** Metadata */
  metadata?: Record<string, any>;
  /** Default Meeting Group Id */
  default_meeting_group_id?: string | null;
  /** Company Id */
  company_id?: string | null;
}

/** WorkspaceCreateResponse */
export interface WorkspaceCreateResponse {
  /** Workspace Id */
  workspace_id: string;
  /** Provider Id */
  provider_id: string;
}

/** WorkspaceDeleteResponse */
export interface WorkspaceDeleteResponse {
  /** Workspace Id */
  workspace_id: string;
  /** Deleted */
  deleted: boolean;
}

/** WorkspaceItem */
export interface WorkspaceItem {
  /** Workspace Id */
  workspace_id: string;
  /** Provider Id */
  provider_id: string;
  /** External Id */
  external_id: string | null;
  /** Display Name */
  display_name: string | null;
  /** Is Active */
  is_active: boolean;
  /** Metadata */
  metadata: Record<string, any>;
}

/** WorkspaceListResponse */
export interface WorkspaceListResponse {
  /** Items */
  items: WorkspaceItem[];
}

/** WorkspaceResponse */
export interface WorkspaceResponse {
  /** Workspace Id */
  workspace_id: string;
  /** Provider Id */
  provider_id: string;
  /** External Id */
  external_id?: string | null;
  /** Display Name */
  display_name?: string | null;
  /** Is Active */
  is_active: boolean;
  /** Metadata */
  metadata: Record<string, any>;
  /** Default Meeting Group Id */
  default_meeting_group_id?: string | null;
}

/** WorkspaceUpdateRequest */
export interface WorkspaceUpdateRequest {
  /** Default Meeting Group Id */
  default_meeting_group_id?: string | null;
  /** Display Name */
  display_name?: string | null;
}

/** JiraConnectRequest */
export interface ApplicationWebRoutersAuthJiraConnectRequest {
  /** User Id */
  user_id: string;
  /** Username */
  username: string;
  /** Password */
  password: string;
  /** Url */
  url: string;
}

/** JiraConnectRequest */
export interface ApplicationWebRoutersIntegrationsJiraConnectRequest {
  /** Username */
  username: string;
  /** Password */
  password: string;
  /** Url */
  url: string;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Volo Discord Integration API
 * @version 0.1.0
 *
 * REST API и WebSocket для интеграции Discord-бота: управление сессиями транскрипции, получение последних транскрипций и события в реальном времени. Все запросы требуют JWT (Bearer).
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  internal = {
    /**
     * No description
     *
     * @tags Internal
     * @name IngestChunkInternalConversationChunkPost
     * @summary Добавить чанк транскрипции (внутренний)
     * @request POST:/internal/conversation/chunk
     * @secure
     */
    ingestChunkInternalConversationChunkPost: (
      data: IngestChunkRequest,
      params: RequestParams = {},
    ) =>
      this.request<IngestChunkResponse, HTTPValidationError>({
        path: `/internal/conversation/chunk`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Внутренний endpoint: Celery после смены статуса (process, finalized, finalization_error) вызывает для рассылки conversation.updated по WebSocket.
     *
     * @tags Internal
     * @name NotifyConversationUpdatedEndpointInternalNotifyConversationUpdatedPost
     * @summary Уведомить подписчиков WS об обновлении конверсации (статус и т.д., вызов из Celery)
     * @request POST:/internal/notify/conversation-updated
     * @secure
     */
    notifyConversationUpdatedEndpointInternalNotifyConversationUpdatedPost: (
      data: NotifyConversationUpdatedBody,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/internal/notify/conversation-updated`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Внутренний endpoint: Celery после успешной генерации протокола вызывает его для рассылки protocol.created. Доступ только из внутренней сети.
     *
     * @tags Internal
     * @name NotifyProtocolCreatedEndpointInternalNotifyProtocolCreatedPost
     * @summary Уведомить подписчиков WS о создании протокола (вызов из Celery/воркеров)
     * @request POST:/internal/notify/protocol-created
     * @secure
     */
    notifyProtocolCreatedEndpointInternalNotifyProtocolCreatedPost: (
      data: NotifyProtocolCreatedBody,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/internal/notify/protocol-created`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Внутренний endpoint: Celery после записи протокола в Neo4j вызывает для рассылки protocol_graph.updated.
     *
     * @tags Internal
     * @name NotifyProtocolGraphUpdatedEndpointInternalNotifyProtocolGraphUpdatedPost
     * @summary Уведомить подписчиков WS об обновлении графа протокола (вызов из Celery/воркеров)
     * @request POST:/internal/notify/protocol-graph-updated
     * @secure
     */
    notifyProtocolGraphUpdatedEndpointInternalNotifyProtocolGraphUpdatedPost: (
      data: NotifyProtocolCreatedBody,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/internal/notify/protocol-graph-updated`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal
     * @name IsGuildLinkedInternalGuildsLinkedGet
     * @summary Проверить, привязана ли гильдия (по X-Bot-Token)
     * @request GET:/internal/guilds/linked
     * @secure
     */
    isGuildLinkedInternalGuildsLinkedGet: (params: RequestParams = {}) =>
      this.request<LinkedGuildResponse, HTTPValidationError>({
        path: `/internal/guilds/linked`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal
     * @name CompleteConversationInternalConversationsConversationIdCompletePost
     * @summary Завершить конверсацию (внутренний)
     * @request POST:/internal/conversations/{conversation_id}/complete
     * @secure
     */
    completeConversationInternalConversationsConversationIdCompletePost: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/internal/conversations/${conversationId}/complete`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Internal
     * @name FinalizeCallWithFileInternalConversationFinalizeCallWithFilePost
     * @summary Финализировать разговор (файл записи опционален)
     * @request POST:/internal/conversation/finalize_call_with_file
     * @secure
     */
    finalizeCallWithFileInternalConversationFinalizeCallWithFilePost: (
      data: BodyFinalizeCallWithFileInternalConversationFinalizeCallWithFilePost,
      params: RequestParams = {},
    ) =>
      this.request<FinalizeCallResponse, HTTPValidationError>({
        path: `/internal/conversation/finalize_call_with_file`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description Принимает чанки транскрипции от Meet и обрабатывает их.
     *
     * @tags Internal
     * @name ReceiveMeetChunkInternalMeetWorkspacesWorkspaceIdChunkPost
     * @summary Принять чанк транскрипции от Meet
     * @request POST:/internal/meet/workspaces/{workspace_id}/chunk
     * @secure
     */
    receiveMeetChunkInternalMeetWorkspacesWorkspaceIdChunkPost: (
      workspaceId: string,
      data: MeetChunkRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeetChunkResponse, HTTPValidationError>({
        path: `/internal/meet/workspaces/${workspaceId}/chunk`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Создает новую конверсацию для Meet workspace по external_id.
     *
     * @tags Internal
     * @name StartMeetConversationInternalMeetStartConversationPost
     * @summary Начать конверсацию Meet
     * @request POST:/internal/meet/start-conversation
     * @secure
     */
    startMeetConversationInternalMeetStartConversationPost: (
      data: MeetStartConversationRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeetStartConversationResponse, HTTPValidationError>({
        path: `/internal/meet/start-conversation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Завершает конверсацию Meet - переводит в waiting_for_finalize если active, ошибка если уже completed.
     *
     * @tags Internal
     * @name EndMeetConversationInternalMeetEndConversationPost
     * @summary Завершить конверсацию Meet
     * @request POST:/internal/meet/end-conversation
     * @secure
     */
    endMeetConversationInternalMeetEndConversationPost: (
      data: MeetEndConversationRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeetEndConversationResponse, HTTPValidationError>({
        path: `/internal/meet/end-conversation`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Internal endpoint: Meet service calls this when a participant joins or leaves a room. Broadcasts participants_changed event to all WebSocket subscribers for the conversation.
     *
     * @tags Internal
     * @name ParticipantsChangedEndpointInternalInternalMeetParticipantsChangedPost
     * @summary Notify about participant changes in Meet room
     * @request POST:/internal/internal/meet/participants-changed
     * @secure
     */
    participantsChangedEndpointInternalInternalMeetParticipantsChangedPost: (
      data: ParticipantsChangedBody,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/internal/internal/meet/participants-changed`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Возвращает предложенный webhook URL для конфигурации FlowAI Whisper провайдера. Webhook URL формируется как: {FLOWAI_WEBHOOK_DOMAIN}/webhook/flowai Этот endpoint используется admin-config для автозаполнения поля webhook_url при конфигурации FlowAI Whisper провайдера.
     *
     * @tags Internal
     * @name GetFlowaiWebhookUrlInternalFlowaiWebhookUrlGet
     * @summary Получить предложенный webhook URL для FlowAI
     * @request GET:/internal/flowai/webhook-url
     * @secure
     */
    getFlowaiWebhookUrlInternalFlowaiWebhookUrlGet: (
      params: RequestParams = {},
    ) =>
      this.request<FlowAIWebhookUrlResponse, any>({
        path: `/internal/flowai/webhook-url`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  webhooks = {
    /**
     * No description
     *
     * @tags Webhooks
     * @name ReceiveProtocolWebhooksProtocolsPost
     * @summary Принять протокол встречи от внешней системы
     * @request POST:/webhooks/protocols
     * @secure
     */
    receiveProtocolWebhooksProtocolsPost: (
      data: WebhookProtocolRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/webhooks/protocols`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  providers = {
    /**
     * @description Создает новый workspace Meet с комнатой для видеоконференций. Поддерживает создание защищенных комнат (protected rooms), которые требуют код доступа для входа. **Параметры:** - `name`: Название встречи/комнаты - `is_protected`: Если `true`, комната будет защищена кодом доступа - `default_meeting_group_id`: Опциональный ID группы встреч **Ответ:** - `workspace_id`: ID созданного workspace - `room_id`: ID комнаты - `meet_room_id`: ID комнаты в Meet API - `slug`: URL-слаг комнаты - `room_url`: Полная ссылка на комнату - `is_protected`: Флаг защищенной комнаты - `access_code`: Код доступа (только для защищенных комнат) - `pin_code`: PIN-код для телефонии (если доступен) **Пример запроса:** ```json { "name": "Team Meeting", "is_protected": true, "default_meeting_group_id": "group-123" } ``` **Пример ответа:** ```json { "workspace_id": "ws-123", "room_id": "room-456", "meet_room_id": "meet-room-789", "slug": "team-meeting-abc", "room_url": "https://meet.example.com/team-meeting-abc", "is_protected": true, "access_code": "ABC123", "pin_code": "1234" } ```
     *
     * @tags Meet Provider
     * @name CreateMeetWorkspaceProvidersMeetWorkspacesPost
     * @summary Создать workspace Meet с комнатой
     * @request POST:/providers/meet/workspaces
     * @secure
     */
    createMeetWorkspaceProvidersMeetWorkspacesPost: (
      data: MeetWorkspaceCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeetWorkspaceCreateResponse, void | HTTPValidationError>({
        path: `/providers/meet/workspaces`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Получает детальную информацию о Meet workspace, включая данные о защищенной комнате. **Параметры:** - `workspace_id`: ID workspace (в path) **Ответ:** - `workspace_id`: ID workspace - `room_id`: ID комнаты - `meet_room_id`: ID комнаты в Meet API - `slug`: URL-слаг комнаты - `room_url`: Полная ссылка на комнату - `is_protected`: Флаг защищенной комнаты - `access_code`: Код доступа (только для защищенных комнат и только для владельца) - `pin_code`: PIN-код для телефонии (если доступен) - `display_name`: Отображаемое имя workspace **Примечание:** `access_code` возвращается только владельцу workspace. **Пример ответа:** ```json { "workspace_id": "ws-123", "room_id": "room-456", "meet_room_id": "meet-room-789", "slug": "team-meeting-abc", "room_url": "https://meet.example.com/team-meeting-abc", "is_protected": true, "access_code": "ABC123", "pin_code": "1234", "display_name": "Team Meeting" } ```
     *
     * @tags Meet Provider
     * @name GetMeetWorkspaceProvidersMeetWorkspacesWorkspaceIdGet
     * @summary Получить детали Meet workspace
     * @request GET:/providers/meet/workspaces/{workspace_id}
     * @secure
     */
    getMeetWorkspaceProvidersMeetWorkspacesWorkspaceIdGet: (
      workspaceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MeetWorkspaceDetailResponse, void | HTTPValidationError>({
        path: `/providers/meet/workspaces/${workspaceId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает Meet-комнаты, в которых есть участники, но еще не создана активная conversation (транскрипция не запущена). В выдачу попадают только workspace из групп встреч, участником которых является текущий пользователь.
     *
     * @tags Meet Provider
     * @name ListActiveMeetRoomsWithoutTranscriptionProvidersMeetActiveRoomsGet
     * @summary Список активных Meet-комнат без транскрипции
     * @request GET:/providers/meet/active-rooms
     * @secure
     */
    listActiveMeetRoomsWithoutTranscriptionProvidersMeetActiveRoomsGet: (
      params: RequestParams = {},
    ) =>
      this.request<ActiveMeetRoomListResponse, HTTPValidationError>({
        path: `/providers/meet/active-rooms`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Генерирует новый код доступа для защищенной комнаты. **Важно:** - Доступно только владельцу workspace - Работает только для защищенных комнат (`is_protected=true`) - Старый код доступа становится недействительным - Новый код автоматически обновляется в Meet API **Параметры:** - `workspace_id`: ID workspace (в path) **Ответ:** - `workspace_id`: ID workspace - `access_code`: Новый сгенерированный код доступа **Пример ответа:** ```json { "workspace_id": "ws-123", "access_code": "XYZ789" } ``` **Ошибки:** - `400`: Workspace не является защищенной комнатой - `403`: Пользователь не является владельцем workspace - `404`: Workspace не найден
     *
     * @tags Meet Provider
     * @name RegenerateAccessCodeProvidersMeetWorkspacesWorkspaceIdRegenerateCodePost
     * @summary Перегенерировать код доступа для защищенной комнаты
     * @request POST:/providers/meet/workspaces/{workspace_id}/regenerate-code
     * @secure
     */
    regenerateAccessCodeProvidersMeetWorkspacesWorkspaceIdRegenerateCodePost: (
      workspaceId: string,
      params: RequestParams = {},
    ) =>
      this.request<RegenerateAccessCodeResponse, void | HTTPValidationError>({
        path: `/providers/meet/workspaces/${workspaceId}/regenerate-code`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновляет настройки приватности для Meet workspace (публичная/защищенная комната). **Важно:** - Доступно только владельцу workspace - При включении защиты (`is_protected=true`) автоматически генерируется код доступа (если отсутствует) - При отключении защиты (`is_protected=false`) код доступа удаляется - Изменения автоматически применяются в Meet API **Параметры:** - `workspace_id`: ID workspace (в path) - `is_protected`: Флаг защищенной комнаты (в body) **Ответ:** - `workspace_id`: ID workspace - `is_protected`: Обновленный флаг защищенной комнаты - `access_code`: Код доступа (только для защищенных комнат) **Пример запроса:** ```json { "is_protected": true } ``` **Пример ответа:** ```json { "workspace_id": "ws-123", "is_protected": true, "access_code": "ABC123" } ``` **Ошибки:** - `400`: Некорректные данные запроса - `403`: Пользователь не является владельцем workspace - `404`: Workspace не найден
     *
     * @tags Meet Provider
     * @name UpdateMeetWorkspacePrivacyProvidersMeetWorkspacesWorkspaceIdPrivacyPatch
     * @summary Обновить настройки приватности Meet workspace
     * @request PATCH:/providers/meet/workspaces/{workspace_id}/privacy
     * @secure
     */
    updateMeetWorkspacePrivacyProvidersMeetWorkspacesWorkspaceIdPrivacyPatch: (
      workspaceId: string,
      data: UpdateMeetWorkspacePrivacyRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        UpdateMeetWorkspacePrivacyResponse,
        void | HTTPValidationError
      >({
        path: `/providers/meet/workspaces/${workspaceId}/privacy`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Генерирует или обновляет код администратора для Meet workspace. **Важно:** - Доступно только владельцу workspace - Старый код администратора становится недействительным - Изменения автоматически применяются в Meet API **Параметры:** - `workspace_id`: ID workspace (в path) - `regenerate`: Если `true`, генерируется новый код (в body) **Ответ:** - `workspace_id`: ID workspace - `admin_code`: Новый код администратора - `admin_url`: Ссылка для входа как админ
     *
     * @tags Meet Provider
     * @name UpdateAdminCodeProvidersMeetWorkspacesWorkspaceIdAdminCodePatch
     * @summary Обновить код администратора Meet workspace
     * @request PATCH:/providers/meet/workspaces/{workspace_id}/admin-code
     * @secure
     */
    updateAdminCodeProvidersMeetWorkspacesWorkspaceIdAdminCodePatch: (
      workspaceId: string,
      data: UpdateAdminCodeRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateAdminCodeResponse, HTTPValidationError>({
        path: `/providers/meet/workspaces/${workspaceId}/admin-code`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Возвращает все ссылки на комнату Meet, включая обычную ссылку и ссылку для администратора. Доступно только владельцу workspace.
     *
     * @tags Meet Provider
     * @name GetMeetWorkspaceLinksProvidersMeetWorkspacesWorkspaceIdLinksGet
     * @summary Получить все ссылки на Meet workspace
     * @request GET:/providers/meet/workspaces/{workspace_id}/links
     * @secure
     */
    getMeetWorkspaceLinksProvidersMeetWorkspacesWorkspaceIdLinksGet: (
      workspaceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MeetWorkspaceLinksResponse, HTTPValidationError>({
        path: `/providers/meet/workspaces/${workspaceId}/links`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers, Providers/Discord
     * @name GetInviteProvidersDiscordInviteGet
     * @summary Получить ссылку-приглашение бота
     * @request GET:/providers/discord/invite
     * @secure
     */
    getInviteProvidersDiscordInviteGet: (params: RequestParams = {}) =>
      this.request<InviteResponse, HTTPValidationError>({
        path: `/providers/discord/invite`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers, Providers/Discord
     * @name LinkGuildProvidersDiscordGuildsPost
     * @summary Связать гильдию с текущим пользователем
     * @request POST:/providers/discord/guilds
     * @secure
     */
    linkGuildProvidersDiscordGuildsPost: (
      data: LinkGuildRequest,
      params: RequestParams = {},
    ) =>
      this.request<LinkGuildResponse, HTTPValidationError>({
        path: `/providers/discord/guilds`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers, Providers/Discord
     * @name ListGuildsProvidersDiscordGuildsGet
     * @summary Список гильдий
     * @request GET:/providers/discord/guilds
     * @secure
     */
    listGuildsProvidersDiscordGuildsGet: (
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Page Size
         * @min 1
         * @max 100
         * @default 20
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedResponseGuildSummary, HTTPValidationError>({
        path: `/providers/discord/guilds`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers, Providers/Discord
     * @name ListVoiceChannelsProvidersDiscordVoiceChannelsGet
     * @summary Получить список голосовых каналов гильдии
     * @request GET:/providers/discord/voice/channels
     * @secure
     */
    listVoiceChannelsProvidersDiscordVoiceChannelsGet: (
      query: {
        /** Guild Id */
        guild_id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<VoiceChannelsResponse, HTTPValidationError>({
        path: `/providers/discord/voice/channels`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers, Providers/Discord
     * @name ConnectVoiceProvidersDiscordVoiceConnectPost
     * @summary Подключить бота к голосовому каналу
     * @request POST:/providers/discord/voice/connect
     * @secure
     */
    connectVoiceProvidersDiscordVoiceConnectPost: (
      data: VoiceConnectRequest,
      params: RequestParams = {},
    ) =>
      this.request<VoiceOperationResponse, HTTPValidationError>({
        path: `/providers/discord/voice/connect`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers, Providers/Discord
     * @name DisconnectVoiceProvidersDiscordVoiceDisconnectPost
     * @summary Отключить бота от голосового канала
     * @request POST:/providers/discord/voice/disconnect
     * @secure
     */
    disconnectVoiceProvidersDiscordVoiceDisconnectPost: (
      data: VoiceDisconnectRequest,
      params: RequestParams = {},
    ) =>
      this.request<VoiceOperationResponse, HTTPValidationError>({
        path: `/providers/discord/voice/disconnect`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers
     * @name ListProvidersProvidersGet
     * @summary List Providers
     * @request GET:/providers
     * @secure
     */
    listProvidersProvidersGet: (params: RequestParams = {}) =>
      this.request<ProviderListResponse, HTTPValidationError>({
        path: `/providers`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Providers
     * @name CreateWorkspaceProvidersProviderIdWorkspacesPost
     * @summary Create Workspace
     * @request POST:/providers/{provider_id}/workspaces
     * @secure
     */
    createWorkspaceProvidersProviderIdWorkspacesPost: (
      providerId: string,
      data: WorkspaceCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceCreateResponse, HTTPValidationError>({
        path: `/providers/${providerId}/workspaces`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить workspace по external ID
     *
     * @tags Providers
     * @name GetWorkspaceByExternalIdProvidersProviderIdWorkspacesByExternalIdExternalIdGet
     * @summary Получить workspace по external ID
     * @request GET:/providers/{provider_id}/workspaces/by-external-id/{external_id}
     * @secure
     */
    getWorkspaceByExternalIdProvidersProviderIdWorkspacesByExternalIdExternalIdGet:
      (providerId: string, externalId: string, params: RequestParams = {}) =>
        this.request<WorkspaceResponse, HTTPValidationError>({
          path: `/providers/${providerId}/workspaces/by-external-id/${externalId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * @description Удаляет workspace и все связанные данные (конверсации, участники и т.д.)
     *
     * @tags Providers
     * @name DeleteWorkspaceProvidersProviderIdWorkspacesWorkspaceIdDelete
     * @summary Удалить workspace
     * @request DELETE:/providers/{provider_id}/workspaces/{workspace_id}
     * @secure
     */
    deleteWorkspaceProvidersProviderIdWorkspacesWorkspaceIdDelete: (
      providerId: string,
      workspaceId: string,
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceDeleteResponse, HTTPValidationError>({
        path: `/providers/${providerId}/workspaces/${workspaceId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  meetingGroups = {
    /**
     * No description
     *
     * @tags Meeting Groups
     * @name ListMeetingGroupsMeetingGroupsGet
     * @summary List Meeting Groups
     * @request GET:/meeting-groups
     * @secure
     */
    listMeetingGroupsMeetingGroupsGet: (
      query?: {
        /** Company Id */
        company_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<MeetingGroupListResponse, HTTPValidationError>({
        path: `/meeting-groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name CreateMeetingGroupMeetingGroupsPost
     * @summary Create Meeting Group
     * @request POST:/meeting-groups
     * @secure
     */
    createMeetingGroupMeetingGroupsPost: (
      data: MeetingGroupCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeetingGroupResponse, HTTPValidationError>({
        path: `/meeting-groups`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name GetMeetingGroupMeetingGroupsMeetingGroupIdGet
     * @summary Get Meeting Group
     * @request GET:/meeting-groups/{meeting_group_id}
     * @secure
     */
    getMeetingGroupMeetingGroupsMeetingGroupIdGet: (
      meetingGroupId: string,
      params: RequestParams = {},
    ) =>
      this.request<MeetingGroupResponse, HTTPValidationError>({
        path: `/meeting-groups/${meetingGroupId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name UpdateMeetingGroupMeetingGroupsMeetingGroupIdPatch
     * @summary Update Meeting Group
     * @request PATCH:/meeting-groups/{meeting_group_id}
     * @secure
     */
    updateMeetingGroupMeetingGroupsMeetingGroupIdPatch: (
      meetingGroupId: string,
      data: MeetingGroupUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeetingGroupResponse, HTTPValidationError>({
        path: `/meeting-groups/${meetingGroupId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name DeleteMeetingGroupMeetingGroupsMeetingGroupIdDelete
     * @summary Delete Meeting Group
     * @request DELETE:/meeting-groups/{meeting_group_id}
     * @secure
     */
    deleteMeetingGroupMeetingGroupsMeetingGroupIdDelete: (
      meetingGroupId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/meeting-groups/${meetingGroupId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name UploadMeetingGroupAudioMeetingGroupsMeetingGroupIdUploadsAudioPost
     * @summary Upload Meeting Group Audio
     * @request POST:/meeting-groups/{meeting_group_id}/uploads/audio
     * @secure
     */
    uploadMeetingGroupAudioMeetingGroupsMeetingGroupIdUploadsAudioPost: (
      meetingGroupId: string,
      data: BodyUploadMeetingGroupAudioMeetingGroupsMeetingGroupIdUploadsAudioPost,
      params: RequestParams = {},
    ) =>
      this.request<MeetingGroupAudioUploadResponse, HTTPValidationError>({
        path: `/meeting-groups/${meetingGroupId}/uploads/audio`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name UploadMeetingGroupAudioMeetingGroupsMeetingGroupIdUploadsPost
     * @summary Upload Meeting Group Audio
     * @request POST:/meeting-groups/{meeting_group_id}/uploads
     * @secure
     */
    uploadMeetingGroupAudioMeetingGroupsMeetingGroupIdUploadsPost: (
      meetingGroupId: string,
      data: BodyUploadMeetingGroupAudioMeetingGroupsMeetingGroupIdUploadsPost,
      params: RequestParams = {},
    ) =>
      this.request<MeetingGroupAudioUploadResponse, HTTPValidationError>({
        path: `/meeting-groups/${meetingGroupId}/uploads`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name GetMeetingGroupAudioUploadStatusMeetingGroupsMeetingGroupIdUploadsUploadJobIdGet
     * @summary Get Meeting Group Audio Upload Status
     * @request GET:/meeting-groups/{meeting_group_id}/uploads/{upload_job_id}
     * @secure
     */
    getMeetingGroupAudioUploadStatusMeetingGroupsMeetingGroupIdUploadsUploadJobIdGet:
      (
        meetingGroupId: string,
        uploadJobId: string,
        params: RequestParams = {},
      ) =>
        this.request<
          MeetingGroupAudioUploadStatusResponse,
          HTTPValidationError
        >({
          path: `/meeting-groups/${meetingGroupId}/uploads/${uploadJobId}`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name AddMeetingGroupMemberMeetingGroupsMeetingGroupIdMembersPost
     * @summary Add Meeting Group Member
     * @request POST:/meeting-groups/{meeting_group_id}/members
     * @secure
     */
    addMeetingGroupMemberMeetingGroupsMeetingGroupIdMembersPost: (
      meetingGroupId: string,
      data: MeetingGroupMemberAddRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeetingGroupMemberAddRequest, HTTPValidationError>({
        path: `/meeting-groups/${meetingGroupId}/members`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name UpdateMeetingGroupMemberRoleMeetingGroupsMeetingGroupIdMembersUserIdPatch
     * @summary Update Meeting Group Member Role
     * @request PATCH:/meeting-groups/{meeting_group_id}/members/{user_id}
     * @secure
     */
    updateMeetingGroupMemberRoleMeetingGroupsMeetingGroupIdMembersUserIdPatch: (
      meetingGroupId: string,
      userId: string,
      data: MeetingGroupMemberRoleUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<MeetingGroupMember, HTTPValidationError>({
        path: `/meeting-groups/${meetingGroupId}/members/${userId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Meeting Groups
     * @name RemoveMeetingGroupMemberMeetingGroupsMeetingGroupIdMembersUserIdDelete
     * @summary Remove Meeting Group Member
     * @request DELETE:/meeting-groups/{meeting_group_id}/members/{user_id}
     * @secure
     */
    removeMeetingGroupMemberMeetingGroupsMeetingGroupIdMembersUserIdDelete: (
      meetingGroupId: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/meeting-groups/${meetingGroupId}/members/${userId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  companies = {
    /**
     * @description Create a company; caller becomes owner. Uses explicit transaction management: all repository operations within this endpoint share the same session and transaction.
     *
     * @tags Companies
     * @name CreateCompanyCompaniesPost
     * @summary Create Company
     * @request POST:/companies
     * @secure
     */
    createCompanyCompaniesPost: (
      data: CreateCompanyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CompanyResponse, HTTPValidationError>({
        path: `/companies`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List companies the current user is a member of, with roles.
     *
     * @tags Companies
     * @name ListCompaniesCompaniesGet
     * @summary List Companies
     * @request GET:/companies
     * @secure
     */
    listCompaniesCompaniesGet: (params: RequestParams = {}) =>
      this.request<CompanyListResponse, HTTPValidationError>({
        path: `/companies`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description List available invite candidates by display_name for the company owner.
     *
     * @tags Companies
     * @name ListInviteCandidatesCompaniesCompanyIdInviteCandidatesGet
     * @summary List Invite Candidates
     * @request GET:/companies/{company_id}/invite-candidates
     * @secure
     */
    listInviteCandidatesCompaniesCompanyIdInviteCandidatesGet: (
      companyId: string,
      query?: {
        /**
         * Q
         * @maxLength 128
         * @default ""
         */
        q?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InviteCandidateListResponse, HTTPValidationError>({
        path: `/companies/${companyId}/invite-candidates`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Create invitation to company (only owner). invitee_id_or_external: app_user.id or external_user_id. Uses explicit transaction management for atomicity.
     *
     * @tags Companies
     * @name CreateInvitationCompaniesCompanyIdInvitationsPost
     * @summary Create Invitation
     * @request POST:/companies/{company_id}/invitations
     * @secure
     */
    createInvitationCompaniesCompanyIdInvitationsPost: (
      companyId: string,
      data: CreateInvitationRequest,
      params: RequestParams = {},
    ) =>
      this.request<InvitationResponse, HTTPValidationError>({
        path: `/companies/${companyId}/invitations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description List outgoing invitations for this company (inviter = current user). Owner and admin only.
     *
     * @tags Companies
     * @name ListCompanyInvitationsCompaniesCompanyIdInvitationsGet
     * @summary List Company Invitations
     * @request GET:/companies/{company_id}/invitations
     * @secure
     */
    listCompanyInvitationsCompaniesCompanyIdInvitationsGet: (
      companyId: string,
      params: RequestParams = {},
    ) =>
      this.request<InvitationListResponse, HTTPValidationError>({
        path: `/companies/${companyId}/invitations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update member role in company. Only owner can change owner role; admin cannot. Uses explicit transaction management for atomicity.
     *
     * @tags Companies
     * @name UpdateCompanyUserRoleCompaniesCompanyIdUsersUserIdRolePatch
     * @summary Update Company User Role
     * @request PATCH:/companies/{company_id}/users/{user_id}/role
     * @secure
     */
    updateCompanyUserRoleCompaniesCompanyIdUsersUserIdRolePatch: (
      companyId: string,
      userId: string,
      data: CompanyUserRoleUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/companies/${companyId}/users/${userId}/role`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Remove member from company (owner/admin only). Cannot remove yourself.
     *
     * @tags Companies
     * @name RemoveCompanyMemberCompaniesCompanyIdUsersUserIdDelete
     * @summary Remove Company Member
     * @request DELETE:/companies/{company_id}/users/{user_id}
     * @secure
     */
    removeCompanyMemberCompaniesCompanyIdUsersUserIdDelete: (
      companyId: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/companies/${companyId}/users/${userId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description List workspaces for a company and provider (owner and admin of company only).
     *
     * @tags Companies
     * @name ListCompanyProviderWorkspacesCompaniesCompanyIdProvidersProviderIdWorkspacesGet
     * @summary List Company Provider Workspaces
     * @request GET:/companies/{company_id}/providers/{provider_id}/workspaces
     * @secure
     */
    listCompanyProviderWorkspacesCompaniesCompanyIdProvidersProviderIdWorkspacesGet:
      (providerId: string, companyId: string, params: RequestParams = {}) =>
        this.request<WorkspaceResponse[], HTTPValidationError>({
          path: `/companies/${companyId}/providers/${providerId}/workspaces`,
          method: "GET",
          secure: true,
          format: "json",
          ...params,
        }),

    /**
     * @description List company members (owner and admin of company only).
     *
     * @tags Companies
     * @name ListCompanyUsersCompaniesCompanyIdUsersGet
     * @summary List Company Users
     * @request GET:/companies/{company_id}/users
     * @secure
     */
    listCompanyUsersCompaniesCompanyIdUsersGet: (
      companyId: string,
      params: RequestParams = {},
    ) =>
      this.request<CompanyUserListResponse, HTTPValidationError>({
        path: `/companies/${companyId}/users`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Get company by ID (user must be a member).
     *
     * @tags Companies
     * @name GetCompanyCompaniesCompanyIdGet
     * @summary Get Company
     * @request GET:/companies/{company_id}
     * @secure
     */
    getCompanyCompaniesCompanyIdGet: (
      companyId: string,
      params: RequestParams = {},
    ) =>
      this.request<CompanyResponse, HTTPValidationError>({
        path: `/companies/${companyId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Update company name (owner/admin only). Uses explicit transaction management for atomicity.
     *
     * @tags Companies
     * @name UpdateCompanyCompaniesCompanyIdPatch
     * @summary Update Company
     * @request PATCH:/companies/{company_id}
     * @secure
     */
    updateCompanyCompaniesCompanyIdPatch: (
      companyId: string,
      data: UpdateCompanyRequest,
      params: RequestParams = {},
    ) =>
      this.request<CompanyResponse, HTTPValidationError>({
        path: `/companies/${companyId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete company (owner only). Cascades to all related data.
     *
     * @tags Companies
     * @name DeleteCompanyCompaniesCompanyIdDelete
     * @summary Delete Company
     * @request DELETE:/companies/{company_id}
     * @secure
     */
    deleteCompanyCompaniesCompanyIdDelete: (
      companyId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/companies/${companyId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  users = {
    /**
     * @description Update user's display name. Blocked for avtoprom.tech users (can_edit_display_name=False).
     *
     * @tags Auth
     * @name UpdateUserDisplayNameUsersMeDisplayNamePatch
     * @summary Update User Display Name
     * @request PATCH:/users/me/display-name
     * @secure
     */
    updateUserDisplayNameUsersMeDisplayNamePatch: (
      data: UpdateDisplayNameRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/users/me/display-name`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  invitations = {
    /**
     * @description List pending invitations for the current user (invitee).
     *
     * @tags Invitations
     * @name ListMyInvitationsInvitationsMeGet
     * @summary List My Invitations
     * @request GET:/invitations/me
     * @secure
     */
    listMyInvitationsInvitationsMeGet: (params: RequestParams = {}) =>
      this.request<InvitationListResponse, HTTPValidationError>({
        path: `/invitations/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Accept invitation: join company as member. Uses explicit transaction management for atomicity: add_member and update_status are executed within a single transaction.
     *
     * @tags Invitations
     * @name AcceptInvitationInvitationsInvitationIdAcceptPost
     * @summary Accept Invitation
     * @request POST:/invitations/{invitation_id}/accept
     * @secure
     */
    acceptInvitationInvitationsInvitationIdAcceptPost: (
      invitationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/invitations/${invitationId}/accept`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Decline invitation (only invitee). Uses explicit transaction management for atomicity.
     *
     * @tags Invitations
     * @name DeclineInvitationInvitationsInvitationIdDeclinePost
     * @summary Decline Invitation
     * @request POST:/invitations/{invitation_id}/decline
     * @secure
     */
    declineInvitationInvitationsInvitationIdDeclinePost: (
      invitationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/invitations/${invitationId}/decline`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * @description Cancel invitation (only inviter or company owner). Uses explicit transaction management for atomicity.
     *
     * @tags Invitations
     * @name CancelInvitationInvitationsInvitationIdDelete
     * @summary Cancel Invitation
     * @request DELETE:/invitations/{invitation_id}
     * @secure
     */
    cancelInvitationInvitationsInvitationIdDelete: (
      invitationId: string,
      params: RequestParams = {},
    ) =>
      this.request<InvitationResponse, HTTPValidationError>({
        path: `/invitations/${invitationId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  workspaces = {
    /**
     * No description
     *
     * @tags Workspaces
     * @name UpdateWorkspaceWorkspacesWorkspaceIdPatch
     * @summary Update Workspace
     * @request PATCH:/workspaces/{workspace_id}
     * @secure
     */
    updateWorkspaceWorkspacesWorkspaceIdPatch: (
      workspaceId: string,
      data: WorkspaceUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceResponse, HTTPValidationError>({
        path: `/workspaces/${workspaceId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Workspaces
     * @name DeleteWorkspaceWorkspacesWorkspaceIdDelete
     * @summary Delete Workspace
     * @request DELETE:/workspaces/{workspace_id}
     * @secure
     */
    deleteWorkspaceWorkspacesWorkspaceIdDelete: (
      workspaceId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/workspaces/${workspaceId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Завершить все активные сессии для workspace.
     *
     * @tags Orchestrator
     * @name EndAllWorkspaceSessionsWorkspacesWorkspaceIdEndAllSessionsPost
     * @summary End All Workspace Sessions
     * @request POST:/workspaces/{workspace_id}/end-all-sessions
     * @secure
     */
    endAllWorkspaceSessionsWorkspacesWorkspaceIdEndAllSessionsPost: (
      workspaceId: string,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, HTTPValidationError>({
        path: `/workspaces/${workspaceId}/end-all-sessions`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name ListWorkspacesWorkspacesGet
     * @summary List Workspaces
     * @request GET:/workspaces
     * @secure
     */
    listWorkspacesWorkspacesGet: (
      query?: {
        /**
         * Provider Id
         * Filter workspaces by provider ID
         */
        provider_id?: string | null;
        /**
         * Default Meeting Group Id
         * Filter workspaces by default meeting group ID
         */
        default_meeting_group_id?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<WorkspaceListResponse, HTTPValidationError>({
        path: `/workspaces`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  auth = {
    /**
     * @description Callback endpoint for Keycloak authorization code flow. Exchanges authorization code for access token and redirects to frontend with token.
     *
     * @tags Auth, Auth
     * @name KeycloakCallbackAuthKeycloakCallbackGet
     * @summary Keycloak Callback
     * @request GET:/auth/keycloak/callback
     * @secure
     */
    keycloakCallbackAuthKeycloakCallbackGet: (
      query?: {
        /** Code */
        code?: string | null;
        /** Error */
        error?: string | null;
        /** State */
        state?: string | null;
        /** Code Verifier */
        code_verifier?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/auth/keycloak/callback`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Return current authenticated user id, display_name, external_user_id and can_edit_display_name (for UI).
     *
     * @tags Auth
     * @name GetCurrentUserInfoAuthMeGet
     * @summary Get Current User Info
     * @request GET:/auth/me
     * @secure
     */
    getCurrentUserInfoAuthMeGet: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/auth/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  google = {
    /**
     * @description Начать OAuth авторизацию
     *
     * @tags Auth
     * @name GoogleAuthStartGoogleStartGet
     * @summary Google Auth Start
     * @request GET:/google/start
     * @secure
     */
    googleAuthStartGoogleStartGet: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/google/start`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Получить URL для OAuth авторизации
     *
     * @tags Auth
     * @name GetGoogleOauthUrlGoogleOauthUrlGet
     * @summary Get Google Oauth Url
     * @request GET:/google/oauth-url
     * @secure
     */
    getGoogleOauthUrlGoogleOauthUrlGet: (
      query: {
        /** Redirect Url */
        redirect_url: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/google/oauth-url`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Callback после авторизации в Google
     *
     * @tags Auth
     * @name GoogleAuthCallbackGoogleCallbackGet
     * @summary Google Auth Callback
     * @request GET:/google/callback
     * @secure
     */
    googleAuthCallbackGoogleCallbackGet: (
      query?: {
        /** Code */
        code?: string;
        /** Error */
        error?: string;
        /** State */
        state?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/google/callback`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Проверить статус подключения Google Calendar
     *
     * @tags Auth
     * @name GoogleAuthStatusGoogleStatusGet
     * @summary Google Auth Status
     * @request GET:/google/status
     * @secure
     */
    googleAuthStatusGoogleStatusGet: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/google/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Отключить Google Calendar
     *
     * @tags Auth
     * @name GoogleDisconnectGoogleDisconnectDelete
     * @summary Google Disconnect
     * @request DELETE:/google/disconnect
     * @secure
     */
    googleDisconnectGoogleDisconnectDelete: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/google/disconnect`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Создать интеграцию Google Calendar
     *
     * @tags Auth
     * @name GoogleCreateGoogleCreatePost
     * @summary Google Create
     * @request POST:/google/create
     * @secure
     */
    googleCreateGoogleCreatePost: (
      data: GoogleCalendarCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/google/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновить Google Calendar credentials
     *
     * @tags Auth
     * @name GoogleUpdateGoogleUpdatePut
     * @summary Google Update
     * @request PUT:/google/update
     * @secure
     */
    googleUpdateGoogleUpdatePut: (
      data: GoogleCalendarUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/google/update`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Удалить интеграцию Google Calendar
     *
     * @tags Auth
     * @name GoogleDeleteGoogleDeleteDelete
     * @summary Google Delete
     * @request DELETE:/google/delete
     * @secure
     */
    googleDeleteGoogleDeleteDelete: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/google/delete`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  jira = {
    /**
     * No description
     *
     * @tags Auth
     * @name JiraConnectJiraConnectPost
     * @summary Jira Connect
     * @request POST:/jira/connect
     * @secure
     */
    jiraConnectJiraConnectPost: (
      data: ApplicationWebRoutersAuthJiraConnectRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/jira/connect`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Проверить статус подключения Jira
     *
     * @tags Auth
     * @name JiraStatusJiraStatusGet
     * @summary Jira Status
     * @request GET:/jira/status
     * @secure
     */
    jiraStatusJiraStatusGet: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/jira/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Отключить Jira
     *
     * @tags Auth
     * @name JiraDisconnectJiraDisconnectDelete
     * @summary Jira Disconnect
     * @request DELETE:/jira/disconnect
     * @secure
     */
    jiraDisconnectJiraDisconnectDelete: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/jira/disconnect`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Создать интеграцию Jira
     *
     * @tags Auth
     * @name JiraCreateJiraCreatePost
     * @summary Jira Create
     * @request POST:/jira/create
     * @secure
     */
    jiraCreateJiraCreatePost: (
      data: JiraCreateRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/jira/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновить Jira credentials
     *
     * @tags Auth
     * @name JiraUpdateJiraUpdatePut
     * @summary Jira Update
     * @request PUT:/jira/update
     * @secure
     */
    jiraUpdateJiraUpdatePut: (
      data: JiraUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/jira/update`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Удалить интеграцию Jira
     *
     * @tags Auth
     * @name JiraDeleteJiraDeleteDelete
     * @summary Jira Delete
     * @request DELETE:/jira/delete
     * @secure
     */
    jiraDeleteJiraDeleteDelete: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/jira/delete`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Выполнить действие в Jira после подтверждения пользователя
     *
     * @tags Jira
     * @name ApproveJiraActionJiraApproveDelete
     * @summary Approve Jira Action
     * @request DELETE:/jira/approve
     * @secure
     */
    approveJiraActionJiraApproveDelete: (
      data: JiraApprovalRequest,
      params: RequestParams = {},
    ) =>
      this.request<JiraApprovalResponse, HTTPValidationError>({
        path: `/jira/approve`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Выполнить действие в Jira после подтверждения пользователя
     *
     * @tags Jira
     * @name ApproveJiraActionJiraApproveDelete2
     * @summary Approve Jira Action
     * @request PUT:/jira/approve
     * @originalName approveJiraActionJiraApproveDelete
     * @duplicate
     * @secure
     */
    approveJiraActionJiraApproveDelete2: (
      data: JiraApprovalRequest,
      params: RequestParams = {},
    ) =>
      this.request<JiraApprovalResponse, HTTPValidationError>({
        path: `/jira/approve`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Выполнить действие в Jira после подтверждения пользователя
     *
     * @tags Jira
     * @name ApproveJiraActionJiraApproveDelete3
     * @summary Approve Jira Action
     * @request POST:/jira/approve
     * @originalName approveJiraActionJiraApproveDelete
     * @duplicate
     * @secure
     */
    approveJiraActionJiraApproveDelete3: (
      data: JiraApprovalRequest,
      params: RequestParams = {},
    ) =>
      this.request<JiraApprovalResponse, HTTPValidationError>({
        path: `/jira/approve`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  integrations = {
    /**
     * @description Все интеграции пользователя со ссылками
     *
     * @tags Auth
     * @name GetAllIntegrationsIntegrationsGet
     * @summary Get All Integrations
     * @request GET:/integrations
     * @secure
     */
    getAllIntegrationsIntegrationsGet: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/integrations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Начать OAuth авторизацию
     *
     * @tags Integrations
     * @name GoogleAuthStartIntegrationsGoogleStartGet
     * @summary Google Auth Start
     * @request GET:/integrations/google/start
     * @secure
     */
    googleAuthStartIntegrationsGoogleStartGet: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/integrations/google/start`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Callback после авторизации в Google
     *
     * @tags Integrations
     * @name GoogleAuthCallbackIntegrationsGoogleCallbackGet
     * @summary Google Auth Callback
     * @request GET:/integrations/google/callback
     * @secure
     */
    googleAuthCallbackIntegrationsGoogleCallbackGet: (
      query?: {
        /** Code */
        code?: string;
        /** Error */
        error?: string;
        /** State */
        state?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/integrations/google/callback`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Проверить статус подключения Google Calendar
     *
     * @tags Integrations
     * @name GoogleAuthStatusIntegrationsGoogleStatusGet
     * @summary Google Auth Status
     * @request GET:/integrations/google/status
     * @secure
     */
    googleAuthStatusIntegrationsGoogleStatusGet: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/integrations/google/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Отключить Google Calendar
     *
     * @tags Integrations
     * @name GoogleDisconnectIntegrationsGoogleDisconnectDelete
     * @summary Google Disconnect
     * @request DELETE:/integrations/google/disconnect
     * @secure
     */
    googleDisconnectIntegrationsGoogleDisconnectDelete: (
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/integrations/google/disconnect`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Подключить Jira Args: request: Jira credentials (username, password, url) current_user: Текущий пользователь из JWT токена
     *
     * @tags Integrations
     * @name JiraConnectIntegrationsJiraConnectPost
     * @summary Jira Connect
     * @request POST:/integrations/jira/connect
     * @secure
     */
    jiraConnectIntegrationsJiraConnectPost: (
      data: ApplicationWebRoutersIntegrationsJiraConnectRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/integrations/jira/connect`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Проверить статус подключения Jira
     *
     * @tags Integrations
     * @name JiraStatusIntegrationsJiraStatusGet
     * @summary Jira Status
     * @request GET:/integrations/jira/status
     * @secure
     */
    jiraStatusIntegrationsJiraStatusGet: (params: RequestParams = {}) =>
      this.request<any, HTTPValidationError>({
        path: `/integrations/jira/status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Отключить Jira
     *
     * @tags Integrations
     * @name JiraDisconnectIntegrationsJiraDisconnectDelete
     * @summary Jira Disconnect
     * @request DELETE:/integrations/jira/disconnect
     * @secure
     */
    jiraDisconnectIntegrationsJiraDisconnectDelete: (
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/integrations/jira/disconnect`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  conversations = {
    /**
     * @description Возвращает полную структуру протокола с темами и элементами из Neo4j
     *
     * @tags Protocol Graph
     * @name GetProtocolGraphConversationsConversationIdProtocolGraphGet
     * @summary Получить протокол встречи из графовой БД
     * @request GET:/conversations/{conversation_id}/protocol/graph
     * @secure
     */
    getProtocolGraphConversationsConversationIdProtocolGraphGet: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<ProtocolGraphResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/protocol/graph`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновляет указанные поля ноды (Protocol, TopicItem, ProtocolItem)
     *
     * @tags Protocol Graph
     * @name UpdateNodeConversationsConversationIdNodesNodeIdPatch
     * @summary Обновить поля ноды
     * @request PATCH:/conversations/{conversation_id}/nodes/{node_id}
     * @secure
     */
    updateNodeConversationsConversationIdNodesNodeIdPatch: (
      conversationId: string,
      nodeId: string,
      data: UpdateNodeRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateNodeResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/nodes/${nodeId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Поставляет задачу генерации протокола в очередь Celery. Протокол будет создан или пересоздан на основе чанков транскрипции.
     *
     * @tags Protocol Graph
     * @name TriggerProtocolGenerateConversationsConversationIdProtocolGeneratePost
     * @summary Запустить или перегенерировать протокол встречи
     * @request POST:/conversations/{conversation_id}/protocol/generate
     * @secure
     */
    triggerProtocolGenerateConversationsConversationIdProtocolGeneratePost: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/conversations/${conversationId}/protocol/generate`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns list of participants for an active Meet conversation.
     *
     * @tags Participants
     * @name GetActiveParticipantsConversationsConversationIdParticipantsGet
     * @summary Get active participants of a conversation
     * @request GET:/conversations/{conversation_id}/participants
     * @secure
     */
    getActiveParticipantsConversationsConversationIdParticipantsGet: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<ActiveParticipantResponse[], HTTPValidationError>({
        path: `/conversations/${conversationId}/participants`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name CreateConversationConversationsPost
     * @summary Create Conversation
     * @request POST:/conversations
     * @secure
     */
    createConversationConversationsPost: (
      data: ConversationCreatePayload,
      params: RequestParams = {},
    ) =>
      this.request<ConversationStatusResponse, HTTPValidationError>({
        path: `/conversations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name ListConversationsConversationsGet
     * @summary List Conversations
     * @request GET:/conversations
     * @secure
     */
    listConversationsConversationsGet: (
      query?: {
        /** Workspace Id */
        workspace_id?: string | null;
        /**
         * Workspace External Id
         * Filter by workspace external ID
         */
        workspace_external_id?: string | null;
        /** Provider Id */
        provider_id?: string | null;
        /** Meeting Group Id */
        meeting_group_id?: string | null;
        /**
         * Status
         * Filter by conversation status (e.g., 'active')
         */
        status?: string | null;
      },
      params: RequestParams = {},
    ) =>
      this.request<ConversationListResponse, HTTPValidationError>({
        path: `/conversations`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name StartConversationConversationsConversationIdStartPost
     * @summary Start Conversation
     * @request POST:/conversations/{conversation_id}/start
     * @secure
     */
    startConversationConversationsConversationIdStartPost: (
      conversationId: string,
      data: ConversationStartPayload,
      params: RequestParams = {},
    ) =>
      this.request<ConversationStatusResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/start`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name CompleteConversationConversationsConversationIdCompletePost
     * @summary Complete Conversation
     * @request POST:/conversations/{conversation_id}/complete
     * @secure
     */
    completeConversationConversationsConversationIdCompletePost: (
      conversationId: string,
      data: ConversationCompletePayload,
      params: RequestParams = {},
    ) =>
      this.request<ConversationStatusResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/complete`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name FinalizeConversationConversationsConversationIdFinalizePost
     * @summary Finalize Conversation
     * @request POST:/conversations/{conversation_id}/finalize
     * @secure
     */
    finalizeConversationConversationsConversationIdFinalizePost: (
      conversationId: string,
      data: ConversationFinalizePayload,
      params: RequestParams = {},
    ) =>
      this.request<ConversationStatusResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/finalize`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name GetConversationConversationsConversationIdGet
     * @summary Get Conversation
     * @request GET:/conversations/{conversation_id}
     * @secure
     */
    getConversationConversationsConversationIdGet: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<ConversationStatusResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Delete conversation
     *
     * @tags Orchestrator
     * @name DeleteConversationConversationsConversationIdDelete
     * @summary Delete Conversation
     * @request DELETE:/conversations/{conversation_id}
     * @secure
     */
    deleteConversationConversationsConversationIdDelete: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/conversations/${conversationId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description Возвращает чанки разговора с пагинацией. Требует доступа к workspace конверсации.
     *
     * @tags Orchestrator
     * @name GetConversationChunksConversationsConversationIdChunksGet
     * @summary Получить чанки разговора
     * @request GET:/conversations/{conversation_id}/chunks
     * @secure
     */
    getConversationChunksConversationsConversationIdChunksGet: (
      conversationId: string,
      query?: {
        /**
         * Page
         * @min 1
         * @default 1
         */
        page?: number;
        /**
         * Page Size
         * @min 1
         * @max 200
         * @default 50
         */
        page_size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ConversationChunksResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/chunks`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orchestrator
     * @name MergeConversationsConversationsMergePost
     * @summary Merge Conversations
     * @request POST:/conversations/merge
     * @secure
     */
    mergeConversationsConversationsMergePost: (
      data: ConversationMergeRequest,
      params: RequestParams = {},
    ) =>
      this.request<ConversationMergeResponse, HTTPValidationError>({
        path: `/conversations/merge`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновляет статус и/или субстатус разговора. Доступно только для AI-сервиса.
     *
     * @tags Orchestrator
     * @name UpdateConversationStatusConversationsConversationIdStatusPost
     * @summary Обновить статус разговора
     * @request POST:/conversations/{conversation_id}/status
     * @secure
     */
    updateConversationStatusConversationsConversationIdStatusPost: (
      conversationId: string,
      data: ConversationStatusUpdateRequest,
      params: RequestParams = {},
    ) =>
      this.request<ConversationStatusResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ListReportsConversationsConversationIdReportsGet
     * @summary List Reports
     * @request GET:/conversations/{conversation_id}/reports
     * @secure
     */
    listReportsConversationsConversationIdReportsGet: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<ConversationReportDTO[], HTTPValidationError>({
        path: `/conversations/${conversationId}/reports`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name CreateReportConversationsConversationIdReportsPost
     * @summary Create Report
     * @request POST:/conversations/{conversation_id}/reports
     * @secure
     */
    createReportConversationsConversationIdReportsPost: (
      conversationId: string,
      data: ConversationReportCreate,
      params: RequestParams = {},
    ) =>
      this.request<ConversationReportDTO, HTTPValidationError>({
        path: `/conversations/${conversationId}/reports`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Атомарно создаёт несколько репортов и их айтемы в одной транзакции
     *
     * @tags Reports
     * @name CreateReportsBatchConversationsConversationIdReportsBatchPost
     * @summary Массовое создание репортов с айтемами
     * @request POST:/conversations/{conversation_id}/reports/batch
     * @secure
     */
    createReportsBatchConversationsConversationIdReportsBatchPost: (
      conversationId: string,
      data: ConversationReportsBatchCreate,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/conversations/${conversationId}/reports/batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Returns a tree structure of all reports and their items for a conversation, containing only IDs and titles.
     *
     * @tags Reports
     * @name GetReportsTreeConversationsConversationIdReportsTreeGet
     * @summary Get a lightweight tree of reports and their items
     * @request GET:/conversations/{conversation_id}/reports/tree
     * @secure
     */
    getReportsTreeConversationsConversationIdReportsTreeGet: (
      conversationId: string,
      params: RequestParams = {},
    ) =>
      this.request<ReportTreeResponse, HTTPValidationError>({
        path: `/conversations/${conversationId}/reports/tree`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  api = {
    /**
     * @description Добавить feedback (оценку) к сообщению
     *
     * @tags Feedback, feedback
     * @name AddFeedbackApiFeedbackPost
     * @summary Add Feedback
     * @request POST:/api/feedback
     * @secure
     */
    addFeedbackApiFeedbackPost: (
      data: FeedbackRequest,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/api/feedback`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name RegisterTokenApiV1PushTokensPost
     * @summary Register Token
     * @request POST:/api/v1/push/tokens
     * @secure
     */
    registerTokenApiV1PushTokensPost: (
      data: RegisterTokenRequest,
      params: RequestParams = {},
    ) =>
      this.request<TokenResponse, HTTPValidationError>({
        path: `/api/v1/push/tokens`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name ListTokensApiV1PushTokensGet
     * @summary List Tokens
     * @request GET:/api/v1/push/tokens
     * @secure
     */
    listTokensApiV1PushTokensGet: (params: RequestParams = {}) =>
      this.request<TokenListResponse, HTTPValidationError>({
        path: `/api/v1/push/tokens`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name DeleteTokenApiV1PushTokensTokenIdDelete
     * @summary Delete Token
     * @request DELETE:/api/v1/push/tokens/{token_id}
     * @secure
     */
    deleteTokenApiV1PushTokensTokenIdDelete: (
      tokenId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, HTTPValidationError>({
        path: `/api/v1/push/tokens/${tokenId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name SendTestNotificationApiV1PushTestPost
     * @summary Send Test Notification
     * @request POST:/api/v1/push/test
     * @secure
     */
    sendTestNotificationApiV1PushTestPost: (
      data: TestNotificationRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, HTTPValidationError>({
        path: `/api/v1/push/test`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Broadcast push notification to multiple users (admin only).
     *
     * @tags Push Notifications
     * @name BroadcastNotificationApiV1PushBroadcastPost
     * @summary Broadcast Notification
     * @request POST:/api/v1/push/broadcast
     * @secure
     */
    broadcastNotificationApiV1PushBroadcastPost: (
      data: BroadcastRequest,
      params: RequestParams = {},
    ) =>
      this.request<Record<string, any>, HTTPValidationError>({
        path: `/api/v1/push/broadcast`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Push Notifications
     * @name InviteGroupMembersToConversationApiV1PushConversationsConversationIdInvitePost
     * @summary Invite Group Members To Conversation
     * @request POST:/api/v1/push/conversations/{conversation_id}/invite
     * @secure
     */
    inviteGroupMembersToConversationApiV1PushConversationsConversationIdInvitePost:
      (
        conversationId: string,
        data: ConversationInviteRequest,
        params: RequestParams = {},
      ) =>
        this.request<ConversationInviteResponse, HTTPValidationError>({
          path: `/api/v1/push/conversations/${conversationId}/invite`,
          method: "POST",
          body: data,
          secure: true,
          type: ContentType.Json,
          format: "json",
          ...params,
        }),
  };
  protocols = {
    /**
     * @description Импортирует протокол из текста транскрипции. Запускает асинхронную задачу генерации протокола из raw text со спикерами.
     *
     * @tags Protocol Import
     * @name ImportProtocolProtocolsImportPost
     * @summary Import Protocol
     * @request POST:/protocols/import
     * @secure
     */
    importProtocolProtocolsImportPost: (
      data: ProtocolImportRequest,
      params: RequestParams = {},
    ) =>
      this.request<ProtocolImportResponse, HTTPValidationError>({
        path: `/protocols/import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  config = {
    /**
     * @description Возвращает переводы статусов и субстатусов разговоров на русский язык.
     *
     * @tags Orchestrator
     * @name GetStatusMappingsConfigStatusMappingsGet
     * @summary Получить переводы статусов
     * @request GET:/config/status-mappings
     * @secure
     */
    getStatusMappingsConfigStatusMappingsGet: (params: RequestParams = {}) =>
      this.request<StatusMappingsResponse, any>({
        path: `/config/status-mappings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  chunks = {
    /**
     * No description
     *
     * @tags Orchestrator
     * @name EnqueueChunkChunksPost
     * @summary Enqueue Chunk
     * @request POST:/chunks
     * @secure
     */
    enqueueChunkChunksPost: (data: ChunkPayload, params: RequestParams = {}) =>
      this.request<ChunkEnqueueResponse, HTTPValidationError>({
        path: `/chunks`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  events = {
    /**
     * @description Позволяет коннектору отправить произвольное событие в оркестратор (без HMAC).
     *
     * @tags Orchestrator
     * @name PublishEventEventsPost
     * @summary Публикация внешнего события
     * @request POST:/events
     * @secure
     */
    publishEventEventsPost: (data: EventPayload, params: RequestParams = {}) =>
      this.request<Record<string, any>, HTTPValidationError>({
        path: `/events`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  healthz = {
    /**
     * No description
     *
     * @tags Internal
     * @name HealthzHealthzGet
     * @summary Проверка состояния сервиса
     * @request GET:/healthz
     * @secure
     */
    healthzHealthzGet: (params: RequestParams = {}) =>
      this.request<any, any>({
        path: `/healthz`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  reports = {
    /**
     * No description
     *
     * @tags Reports
     * @name GetReportReportsReportIdGet
     * @summary Get Report
     * @request GET:/reports/{report_id}
     * @secure
     */
    getReportReportsReportIdGet: (
      reportId: string,
      params: RequestParams = {},
    ) =>
      this.request<ConversationReportDTO, HTTPValidationError>({
        path: `/reports/${reportId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name DeleteReportReportsReportIdDelete
     * @summary Delete Report
     * @request DELETE:/reports/{report_id}
     * @secure
     */
    deleteReportReportsReportIdDelete: (
      reportId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/reports/${reportId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ListItemsReportsReportIdItemsGet
     * @summary List Items
     * @request GET:/reports/{report_id}/items
     * @secure
     */
    listItemsReportsReportIdItemsGet: (
      reportId: string,
      params: RequestParams = {},
    ) =>
      this.request<ConversationReportItemDTO[], HTTPValidationError>({
        path: `/reports/${reportId}/items`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Manually handle the creation of a ConversationReportItem to correctly map the 'data' field to the 'data_json' column in the database, bypassing the repository's abstract method.
     *
     * @tags Reports
     * @name AddItemReportsReportIdItemsPost
     * @summary Add Item
     * @request POST:/reports/{report_id}/items
     * @secure
     */
    addItemReportsReportIdItemsPost: (
      reportId: string,
      data: ConversationReportItemCreate,
      params: RequestParams = {},
    ) =>
      this.request<ConversationReportItemDTO, HTTPValidationError>({
        path: `/reports/${reportId}/items`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name DeleteItemReportsItemsItemIdDelete
     * @summary Delete Item
     * @request DELETE:/reports/items/{item_id}
     * @secure
     */
    deleteItemReportsItemsItemIdDelete: (
      itemId: string,
      params: RequestParams = {},
    ) =>
      this.request<any, HTTPValidationError>({
        path: `/reports/items/${itemId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name UpdateItemReportsItemsItemIdPut
     * @summary Update Item
     * @request PUT:/reports/items/{item_id}
     * @secure
     */
    updateItemReportsItemsItemIdPut: (
      itemId: string,
      data: ConversationReportItemUpdate,
      params: RequestParams = {},
    ) =>
      this.request<ConversationReportItemDTO, HTTPValidationError>({
        path: `/reports/items/${itemId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  v1 = {
    /**
     * No description
     *
     * @tags Reports
     * @name CreateReportFromAiV1ReportsAiPost
     * @summary Create Report From Ai
     * @request POST:/v1/reports/ai
     * @secure
     */
    createReportFromAiV1ReportsAiPost: (
      data: ConversationReportsBatchCreate,
      params: RequestParams = {},
    ) =>
      this.request<ConversationReportWithItemsDTO, HTTPValidationError>({
        path: `/v1/reports/ai`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
